/**
 * Вычисляет абсолютную разницу между двумя датами в полных годах, месяцах и днях.
 *
 * Особенности:
 * - Сравниваются только год, месяц и день; часы, минуты и секунды игнорируются.
 * - Возвращаемые значения всегда положительные: { years, months, days } ≥ 0.
 * - Корректно обрабатывает конец месяца (например, 31 января → 28/29 февраля = 1 месяц).
 * - Порядок аргументов не важен: функция сама определяет меньшую и большую дату.
 * - Месяцы и дни считаются "человечески": частично пройденный месяц или день учитывается только если полностью прошёл.
 *
 * @param {Date} a - Первая дата
 * @param {Date} b - Вторая дата
 * @returns {{ years: number, months: number, days: number }} Объект с полными годами, месяцами и днями между датами
 */
export const diffDates = (a: Date, b: Date) => {
  // Исключаем влияние часов и минут
  const start = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  const end = new Date(b.getFullYear(), b.getMonth(), b.getDate());

  // Определяем меньшую и большую даты
  const [smaller, bigger] = start < end ? [start, end] : [end, start];

  let years = bigger.getFullYear() - smaller.getFullYear();
  let months = bigger.getMonth() - smaller.getMonth();
  let days = bigger.getDate() - smaller.getDate();

  // Коррекция дней с учётом последних дней месяца
  if (days < 0) {
    // 0 число месяца вернет последний день прошлого месяца
    const smallerMonthLastDay = new Date(smaller.getFullYear(), smaller.getMonth() + 1, 0).getDate();
    const biggerMonthLastDay = new Date(bigger.getFullYear(), bigger.getMonth() + 1, 0).getDate();

    if (smaller.getDate() === smallerMonthLastDay && bigger.getDate() === biggerMonthLastDay) {
      days = 0; // полный месяц, остатка дней нет
    } else {
      months--;
      if (months < 0) {
        years--;
        months += 12;
      }
      const prevMonthLastDay = new Date(bigger.getFullYear(), bigger.getMonth(), 0).getDate();
      days += prevMonthLastDay;
    }
  }

  // Коррекция месяцев после дней
  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months, days };
};
